import { Injectable } from '@angular/core';

import {
  VehiclesApiService,
  AuthenticatedApiService,
  Vehicle,
  ApiService,
} from 'rest-client';
import { from, Observable } from 'rxjs';

import {
  CarMakesResponse,
  CarModelsResponse,
  MissingCarFormPayload,
  RequestedVehicleDataPayload,
  RequestedVehicleDataResponse,
  MotorResponse,
  BodyResponse,
  CarPropulsionsResponse,
  UmcPayload,
} from '@app/modules/shared/models';
@Injectable({
  providedIn: 'root',
})
export class VehicleService {
  constructor(
    private vehiclesApiService: VehiclesApiService,
    private authenticatedApi: AuthenticatedApiService,
    private unauthenticatedApi: ApiService
  ) {}

  listClientVehicles(): Observable<Vehicle[]> {
    return from(this.vehiclesApiService.listVehicles());
  }

  getClientVehicle(vehicle_id: number, idClient?: number): Observable<Vehicle> {
    return from(this.vehiclesApiService.getVehicle(vehicle_id, idClient));
  }

  createVehicle(
    params: Record<string, unknown> | UmcPayload,
    identify?: boolean
  ): Observable<Vehicle> {
    return from(this.vehiclesApiService.createVehicle(params, identify));
  }

  checkClientVehiclePlate(
    params: Record<string, unknown> | UmcPayload
  ): Observable<Vehicle> {
    return from(this.vehiclesApiService.createVehicle(params, true));
  }

  identifyVehicle(vehicle_id: number): Observable<Vehicle> {
    return from(
      this.vehiclesApiService.identifyVehicle(vehicle_id)
    ) as Observable<Vehicle>;
  }

  updateUserVehicle(vehicle: Vehicle): Observable<Vehicle> {
    return from(this.vehiclesApiService.updateVehicle(vehicle));
  }

  deleteVehicle(vehicle_id: number): Observable<any> {
    return from(this.vehiclesApiService.deleteVehicle(vehicle_id));
  }

  setVehicleWorkshopType(
    vehicle_id: number,
    workshop_type: number
  ): Observable<any> {
    return from(
      this.vehiclesApiService.setVehicleWorkshopType(vehicle_id, workshop_type)
    );
  }

  setVehicleUmc(vehicle_id: number, payload: UmcPayload): Observable<any> {
    return from(this.vehiclesApiService.setVehicleUmc(vehicle_id, payload));
  }

  setRequestedVehicleData(
    id_vehicle: number,
    payload: RequestedVehicleDataPayload
  ): Observable<RequestedVehicleDataResponse> {
    return this.authenticatedApi.post(
      `vehicle/car_details/${id_vehicle}`,
      payload
    ) as Observable<RequestedVehicleDataResponse>;
  }

  setRequestedVehicleDataGuest(
    id_vehicle: number,
    payload: RequestedVehicleDataPayload
  ): Observable<RequestedVehicleDataResponse> {
    return this.unauthenticatedApi.post(
      `vehicle/car_details/${id_vehicle}`,
      payload
    ) as Observable<RequestedVehicleDataResponse>;
  }

  getCarMakes(): Observable<CarMakesResponse> {
    return from(
      this.vehiclesApiService.getCarMakes()
    ) as Observable<CarMakesResponse>;
  }

  getCarModels(id_gt_carmake: number): Observable<CarModelsResponse> {
    return from(
      this.vehiclesApiService.getCarModels(id_gt_carmake)
    ) as Observable<CarModelsResponse>;
  }

  getCarPropulsions(
    id_gt_carmodel: number
  ): Observable<CarPropulsionsResponse> {
    return from(
      this.vehiclesApiService.getCarPropulsions(id_gt_carmodel)
    ) as Observable<CarPropulsionsResponse>;
  }
  getCarPropulsionsbyUmc(
    umc: string
  ): Observable<any> {
    return from(
      this.unauthenticatedApi
        .get(`/vehicle/propulsion_options?umc=${umc}`)
        .toPromise()
    );
  }

  getUmcDatabyUmc(umc: string): Observable<any> {
    return from(this.unauthenticatedApi
      .get(`/vehicle/umc_data/${umc}`)
      .toPromise()
    );
  }


  getCarPropulsionsbyModelDescription(
    car_model_description: string
  ): Observable<CarPropulsionsResponse> {
    return from(
      this.vehiclesApiService.getCarPropulsionsbyModelDescription(
        car_model_description
      )
    ) as Observable<CarPropulsionsResponse>;
  }

  getBodyOptions(
    vehicle_id: number,
    idClient?: number
  ): Observable<BodyResponse> {
    return from(
      this.vehiclesApiService.getBodyOptions(vehicle_id, idClient)
    ) as Observable<BodyResponse>;
  }

  getMotorOptions(
    vehicle_id: number,
    idClient?: number
  ): Observable<MotorResponse> {
    return from(
      this.vehiclesApiService.getMotorOptions(vehicle_id, idClient)
    ) as Observable<MotorResponse>;
  }

  sendMissingCarModel(payload: MissingCarFormPayload): Observable<any> {
    return from(
      this.authenticatedApi
        .post(`/vehicle/missing_car_model`, payload)
        .toPromise()
    );
  }

  sendMissingCarModelGuest(payload: MissingCarFormPayload): Observable<any> {
    return from(
      this.unauthenticatedApi
        .post(`/vehicle/missing_car_model`, payload)
        .toPromise()
    );
  }

  clearVehicle(vehicleId: number): Observable<any> {
    return from(
      this.authenticatedApi
        .delete(`/vehicle/clear_vehicle_identification/${vehicleId}`)
        .toPromise()
    );
  }

  clearVehicleGuest(vehicleId: number): Observable<any> {
    return from(
      this.unauthenticatedApi
        .delete(`/vehicle/clear_vehicle_identification/${vehicleId}`)
        .toPromise()
    );
  }
}
